module.exports = __webpack_public_path__ + "img/austria-stomach-cancer-male.be6b8862.png";